/**
 * RYZE Free Shipping Progress Bar — Cart Drawer + Cart Page
 * ─────────────────────────────────────────────────────────
 * Updates ALL progress bar instances (drawer + /cart page)
 * after any client-side cart change. The bar HTML is rendered
 * server-side via Liquid. This JS handles dynamic updates,
 * the "complete" glow state, and re-render survival.
 */
(function () {
  'use strict';
  if (window.__ryzeFreeShipInit) return;
  window.__ryzeFreeShipInit = true;

  /* ── Detect threshold from the bar's data attribute ──────── */
  function getThreshold() {
    var bar = document.querySelector('.ryze-free-ship[data-threshold]');
    if (bar) return Number(bar.dataset.threshold) || 180000;
    return 180000;
  }

  /* The rendered figure for the empty-cart sentence, from the SAME theme
     setting Liquid rendered the bar with (owner call 2026-08-20: one source
     of truth). The literal is only a last resort for a bar rendered by an
     older cached page that carries no label. */
  function thresholdLabel() {
    var bar = document.querySelector('.ryze-free-ship[data-threshold-label]');
    var label = bar ? bar.getAttribute('data-threshold-label') : '';
    if (!label) return 'LE 1,800';
    /* The label is written into innerHTML below, and a shop money format may
       legally contain markup, so it is escaped here rather than trusted. */
    return label
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* ── Format EGP price (auto-detect cents vs major) ───────── */
  /* dev2.15-fix-cart 2026-10-30: mirrors Liquid's money_without_trailing_zeros
     (the cards' and the cart's format since that pass): "LE 950", never
     "LE 950.00"; a figure with piastres keeps its two decimals. */
  function formatMoney(amount, isCents) {
    var val = isCents ? amount / 100 : amount;
    var whole = Math.round(val * 100) % 100 === 0;
    return 'LE\u00A0' + val.toLocaleString('en-EG', {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2,
    });
  }

  /* ── Update ALL bar elements with cart data ──────────────── */
  function updateAllBars(totalPrice) {
    var bars = document.querySelectorAll('.ryze-free-ship');
    if (!bars.length) return;

    // Shopify cart.total_price is always in cents; treat it as cents unconditionally
    var isCents = true;
    /* From the bar's own data-threshold (Liquid-rendered), not a constant:
       getThreshold() existed but was never called, so the knob the markup
       carried was silently ignored (Part8 audit). */
    var threshold = getThreshold();

    var remaining = threshold - totalPrice;
    if (remaining < 0) remaining = 0;
    var pct = Math.min((totalPrice / threshold) * 100, 100);
    var isComplete = remaining <= 0 && totalPrice > 0;
    var isEmpty = totalPrice === 0;

    bars.forEach(function (bar) {
      // Update fill width
      var fill = bar.querySelector('.ryze-free-ship__fill');
      if (fill) fill.style.width = pct + '%';

      // Update text
      var text = bar.querySelector('.ryze-free-ship__text');
      if (text) {
        /* Cart v2 copy (2026-08-01): the emojis retired with the redesign;
           these strings mirror the Liquid render in main-cart-items.liquid
           word for word, so an update never visibly rewrites the sentence.
           31 Oct 2026 (dev2.16-returns-copy): the threshold holds in every
           governorate, so the bar names no zone. */
        if (isEmpty) {
          text.innerHTML = 'Free delivery on orders above <strong>' + thresholdLabel() + '</strong>';
        } else if (isComplete) {
          text.innerHTML = '<strong>Free delivery unlocked</strong>';
        } else {
          text.innerHTML = 'You\u2019re <strong>' + formatMoney(remaining, isCents) + '</strong> away from <strong>free delivery</strong>';
        }
      }

      // Toggle complete class for glow effect
      bar.classList.toggle('ryze-free-ship--complete', isComplete);
    });
  }

  /* ── Scan all bars and apply "complete" class if fill >= 100% ── */
  function applyCompleteState() {
    document.querySelectorAll('.ryze-free-ship').forEach(function (bar) {
      var fill = bar.querySelector('.ryze-free-ship__fill');
      if (fill) {
        var width = parseFloat(fill.style.width || '0');
        if (width >= 100) bar.classList.add('ryze-free-ship--complete');
      }
    });
  }

  /* ── Fetch cart and update all bars ──────────────────────── */
  function refreshBar() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateAllBars(cart.total_price);
      })
      .catch(function () {});
  }

  /* ── Subscribe to events + observe DOM ──────────────────── */
  function listen() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(applyCompleteState, 100);
      });
    }

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function () {
        applyCompleteState();
      }).observe(drawer, { childList: true, subtree: true });
    }

    var cartItems = document.getElementById('main-cart-items');
    if (cartItems) {
      new MutationObserver(function () {
        applyCompleteState();
      }).observe(cartItems, { childList: true, subtree: true });
    }
  }

  /* ── Init ─────────────────────────────────────────────────── */
  function init() {
    applyCompleteState();
    listen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ryzeRefreshFreeShip = refreshBar;
})();